<template>
  <div class="page-invoices">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">My Invoices</h1>
    <div v-if="loading" class="row">
      <div class="col">
        <br />Loading... Please Wait...
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <!--- <p>Tip: to pay multiple invoices at once, check the boxes on the left and click "Pay Multiple"</p> -->
        <b-table class="mt-3" striped hover :items="items" :fields="fields">
          <template v-slot:cell(ArvcId)="data">
            <!--<span v-if="data.item.Status === 'Unpaid'" style="display:inline-block; width: 20px;"><input type="checkbox" /></span>
            <span v-else style="display:inline-block; width: 20px;">&nbsp;</span>-->
            <router-link :to="`/invoice/${data.item.Id}`">{{ data.value }}</router-link>
          </template>
          <template v-slot:cell(Account)="data">
            <v-clamp autoresize :max-lines="1">{{ data.value }}</v-clamp>
          </template>
          <template v-slot:cell(Name)="data">
            <v-clamp autoresize :max-lines="1">{{ data.value }}</v-clamp>
          </template>
          <template v-slot:cell(actions)="data">
            <router-link :to="`/invoice/${data.item.Id}`" style="margin-left: 10px;"><b-icon-cart /> View / Pay</router-link>
          </template>
        </b-table>
       <!-- <div style="position: absolute; top: -8px; right: 16px;"><b-button class="action-button" variant="success">Pay Mulitple</b-button></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VClamp from 'vue-clamp';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Invoices',
  components: {
    VClamp,
  },
  data() {
    return {
      loading: true,
      test: 'test',
      items: [],
      fields: [
        {
          key: 'ArvcId',
          label: 'Invoice',
          sortable: true,
        },
        {
          key: 'Account',
          label: 'Business',
          sortable: true,
        },
        {
          key: 'Name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'Date',
          label: 'Date',
          sortable: true,
        },
        {
          key: 'Status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'Total',
          label: 'Total',
          sortable: true,
        },
        { key: 'actions', label: '' },
      ],
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawItems = await axios.get(`${server}/api/invoices`);
        if (rawItems.data.redirect) {
          window.location.href = rawItems.data.redirect;
          return;
        }
        this.items = rawItems.data;
        this.loading = false;
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>
